import type { GetCurrentIesUseCase } from '@/application/port/in/IesUseCase';
import type { IesGateway } from '@/application/port/out/IesGateway';
import type { Ies } from '@/domain/model/Ies';

export class GetCurrentIesUseCaseImpl implements GetCurrentIesUseCase {
  constructor(private readonly gateway: IesGateway) {}

  execute(): Promise<Ies> {
    return this.gateway.getCurrent();
  }
}
